import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { Feature } from '@tacliatech/types';
import { PermissionService } from '@web-frontend/shared/services/permissions';
import { Subscription } from 'rxjs';
import { DownloadType } from '../download-btn.component';
import { DownloadBtnService } from '../download-btn.service';

@Component({
  selector: 'roma-shared-download-mobile-btn',
  templateUrl: './download-btn-mobile.component.html',
  styleUrls: ['./download-btn-mobile.component.scss'],
})
export class DownloadBtnMobileComponent implements OnInit, OnDestroy {
  featureRef = Feature;
  featureExcel: Feature.Purchasable = this.featureRef.SystemPermission
    .DefaultAllow;
  featurePdf: Feature.Purchasable = this.featureRef.SystemPermission
    .DefaultAllow;
  featureOther: Feature.Purchasable = this.featureRef.SystemPermission
    .DefaultAllow;
  showDownloadExcel = false;
  showDownloadPdf = false;
  showDownloadOther = false;
  downloadOtherText = 'general.downloadOther';

  sub$ = new Subscription();
  type = DownloadType;

  constructor(
    private permissionService: PermissionService,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private bottomSheetRef: MatBottomSheetRef<DownloadBtnMobileComponent>,
    private readonly downloadBtnService: DownloadBtnService
  ) {
    this.featureExcel = data.featureExcel;
    this.featurePdf = data.featurePdf;
    this.featureOther = data.featureOther;
    this.showDownloadExcel = data.showDownloadExcel;
    this.showDownloadPdf = data.showDownloadPdf;
    this.showDownloadOther = data.showDownloadOther;
    this.downloadOtherText = data.downloadOtherText;
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.sub$.unsubscribe();
  }

  get hasFeaturePdf() {
    return this.permissionService.hasFeatureFn(this.featurePdf);
  }

  get hasFeatureExcel() {
    return this.permissionService.hasFeatureFn(this.featureExcel);
  }

  get hasFeatureOther() {
    return this.permissionService.hasFeatureFn(this.featureOther);
  }

  closeBottomSheet(type: DownloadType | null = null) {
    this.bottomSheetRef.dismiss(type);
  }

  triggerDownload(type: DownloadType) {
    this.downloadBtnService.isLoading.next(true);
    this.closeBottomSheet(type);
  }
}
